import styles from "./index.module.scss";
import Breadcrumbs from "../../common/breadcrumbs";

export default function Side({ title, isBaltex, children, side }) {
  return (
    <div className="container">
      <Breadcrumbs />
      {isBaltex && title && <h1 className={styles.BaltexH1}>{title}</h1>}
      <div className={styles.Content}>
        <div className={styles.Side}>{side}</div>
        <div className={styles.Block}>
          {!isBaltex && title && <h1>{title}</h1>}
          {children}
        </div>
      </div>
    </div>
  );
}
